export default "__VITE_ASSET__a7215629__"